import { api } from './client';
import type { RoomInviteDto } from './types';

export const roomInvitesApi = {
  mine: () => api.get<RoomInviteDto[]>('/me/room-invites'),
  count: () => api.get<{ count: number }>('/me/room-invites/count'),
  accept: (id: string) => api.post<RoomInviteDto>(`/me/room-invites/${id}/accept`),
  reject: (id: string) => api.post<RoomInviteDto>(`/me/room-invites/${id}/reject`),
};
